import Global from '../global'
Global.init()
